import { createElement } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';
import { toggleFormat } from '@wordpress/rich-text';
import { RichTextToolbarButton } from '@wordpress/block-editor';
var name = 'core/strikethrough';

var title = __('Strikethrough');

export var strikethrough = {
  name: name,
  title: title,
  tagName: 's',
  className: null,
  edit: function edit(_ref) {
    var isActive = _ref.isActive,
        value = _ref.value,
        onChange = _ref.onChange;

    var onToggle = function onToggle() {
      return onChange(toggleFormat(value, {
        type: name
      }));
    };

    return createElement(RichTextToolbarButton, {
      icon: "editor-strikethrough",
      title: title,
      onClick: onToggle,
      isActive: isActive
    });
  }
};
//# sourceMappingURL=index.js.map